import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';

export const StyledRadioLabel = styled(FormControlLabel)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1.5),
  borderRadius: 12,
  border: `1px solid ${theme.palette.divider}`,
}));
